module.exports = __webpack_public_path__ + "img/straight_line_icon_124.59a911f9.svg";